import { useEffect, useState } from "react";
import { api, formatApiError } from "@/lib/api";
import { formatDate, statusTone } from "@/lib/format";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import RichText from "@/components/app/RichText";
import { FileText } from "lucide-react";

const Row = ({ label, children, testid }) => (
  <div><div className="label-caps text-[10px]">{label}</div><div className="text-sm mt-0.5" data-testid={testid}>{children || "—"}</div></div>
);

export default function WoDetailDialog({ woId, onClose }) {
  const [wo, setWo] = useState(null);
  const [err, setErr] = useState("");

  useEffect(() => {
    if (!woId) return;
    setWo(null); setErr("");
    api.get(`/work-orders/${woId}`).then((r) => setWo(r.data)).catch((e) => setErr(formatApiError(e)));
  }, [woId]);

  const p = wo?.project || {};
  return (
    <Dialog open={!!woId} onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="rounded-[1.25rem] max-w-2xl max-h-[90vh] overflow-auto" data-testid="wo-detail-dialog">
        {err && <div className="text-sm text-[#B02A00]" data-testid="wo-detail-error">{err}</div>}
        {!wo && !err && <div className="text-sm text-neutral-500 py-8 text-center">Loading…</div>}
        {wo && (
          <>
            <DialogHeader>
              <div className="flex items-center gap-2 flex-wrap">
                <span data-testid="wo-detail-status" className={`px-2 py-0.5 text-xs font-mono-tight uppercase rounded ${statusTone(wo.status)}`}>{wo.status}</span>
                {wo.deadline && <span className="text-xs font-mono-tight text-neutral-500">Due {formatDate(wo.deadline)}</span>}
              </div>
              <DialogTitle className="font-display text-2xl sm:text-3xl text-royal-800 mt-2" data-testid="wo-detail-title">{wo.title}</DialogTitle>
            </DialogHeader>
            <div className="border border-black/10 rounded-xl p-4 bg-cream/40">
              <div className="label-caps mb-2">Description</div>
              <RichText html={wo.description_html} text={wo.description} testid="wo-detail-description" className="text-sm leading-relaxed"
                empty={<div data-testid="wo-detail-empty" className="flex items-center gap-2 text-sm text-neutral-500 py-3"><FileText size={16} /> No description has been added for this work order yet.</div>} />
            </div>
            <div className="grid grid-cols-2 sm:grid-cols-3 gap-4 mt-2" data-testid="wo-detail-project">
              <Row label="Project ID" testid="wo-detail-project-id">{p.project_number}</Row>
              <Row label="Project" testid="wo-detail-project-name">{p.name}</Row>
              <Row label="Project status">{p.status}</Row>
              <Row label="Service">{p.service_name}</Row>
              <Row label="Manager">{p.manager_name}</Row>
              <Row label="Project due">{p.due_date ? formatDate(p.due_date) : ""}</Row>
            </div>
          </>
        )}
      </DialogContent>
    </Dialog>
  );
}
